import * as React from 'react';
const NoViewError = ({ view }) => (React.createElement("p", null, `Error, no ${view} view known`));
export default NoViewError;
